import useAuth from '@/hooks/useAuth'
import regions from '@/services/api/regions'
import { useEffect, useState } from 'react'

function extractRows(data) {
  if (Array.isArray(data)) return data
  return data?.rows || []
}

async function fetchRegionsWithPolygon() {
  const firstResponse = await regions.list({ page: 1 })
  const totalPages = Number(firstResponse.data?.pages) || 1
  const remainingPages = Array.from(
    { length: totalPages - 1 },
    (_, index) => regions.list({ page: index + 2 }),
  )
  const responses = [firstResponse, ...await Promise.all(remainingPages)]
  const uniqueRegions = new Map()

  responses.forEach(({ data }) => {
    extractRows(data).forEach((region) => uniqueRegions.set(region.id, region))
  })

  const detailedRegions = await Promise.all(
    [...uniqueRegions.values()].map(async (region) => {
      if (region?.polygon?.coordinates?.length) return region

      try {
        const { data } = await regions.show(region.id)
        return data
      } catch {
        return null
      }
    }),
  )

  return detailedRegions.filter((region) => (
    region?.polygon?.coordinates?.length
  ))
}

export default function useRegionsWithPolygon() {
  const { licensing } = useAuth()
  const [regionsWithPolygon, setRegionsWithPolygon] = useState([])

  useEffect(() => {
    let active = true

    if (!licensing?.id) {
      setRegionsWithPolygon([])
      return undefined
    }

    fetchRegionsWithPolygon()
      .then((data) => {
        if (active) setRegionsWithPolygon(data)
      })
      .catch(() => {
        if (active) setRegionsWithPolygon([])
      })

    return () => {
      active = false
    }
  }, [licensing?.id])

  return regionsWithPolygon
}
